// Initialize BASE URL
if (false) {
  var BASE_URL = "https://dev.sumpalarm.com";
} else {
  var BASE_URL = "https://dash.sumpalarm.com:8000";
}

$(document).ready(function () {
  
  // LOGIN API
  $(document).on('click', 'input[type="submit"][value="Sign In"]', function (e) {
    var obj = {};
    e.preventDefault();
    obj['email'] = $("#customer_email").val();
    obj['password'] = $("#customer_password").val();
    $.ajax({
      url: BASE_URL + "/api/users/login/",
      type: 'POST',
      data: JSON.stringify(obj),
      dataType: 'json',
      crossDomain: true,
      async: true,
      headers: {
        'api-key': "EdvqRnCQYlzqNLjLEv9Q"
      },
      contentType: 'application/json; charset=utf-8',
      success: function (result) { 
        window.localStorage.setItem("user-token", result.token);
        $("#customer_login").submit();
      },
      error: function (error) {
        err_html = "<div class='note form-error'><p>Sorry, looks like something went wrong. Please correct the following and submit again:</p><ul class='disc'><li>Invalid login credentials.</li></ul></div>";
        jQuery('#customer_login').find(".form_errors").html(err_html);
        $(".reg_form_errors").hide();
        jQuery('#customer_login').find(".form_errors").show();
        document.getElementById("customr-form").reset();
        console.log("Login Errors: ",error);
      }
    });
  });
  
  // ExtractEmails
  function extractEmails (text){
    return text.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi);
  }
  
  // Validate reset password form
  function validate_customr_reset_form() {
    var form = jQuery(".reset_customer_password form");
    form.validate({
      errorElement: 'div',
      errorClass: 'errors',
      highlight: function(element, errorClass, validClass) {
        jQuery(element).addClass("has-error");
      },
      unhighlight: function(element, errorClass, validClass) {
        jQuery(element).removeClass("has-error");
      },
      rules: {
        "customer[password]": {
          required: true,
          minlength: 5
        },
        "customer[password_confirmation]": {
          equalTo: "#reset_password",
        },
      },
      errorPlacement: function(error, element) {
        error.insertAfter(element);
      },
      messages: {
        "customer[password]": {
          required: "Password is required.",
          minlength: "Password is too short (minimum is 5 characters)",
        },
        "customer[password_confirmation]" : {
          equalTo: "Password should be same.",
        },
      }
    });
    return form;
  }
  
  
  // UPDATE PASSWORD API
  $(document).on('click', 'input[type="submit"][value="Reset Password"]', function(e){
    var obj={};
    e.preventDefault();
    var sid = $('.reset_customer_password input[name="id"]').val();
    console.log("Sid", sid);
    obj['password'] = $("#reset_password").val();
    var form = validate_customr_reset_form();
    if (form.valid() === true){
      $.ajax({
        url: BASE_URL+"/api/users/"+sid+"/password_update/",
        type: 'PUT',
        data: JSON.stringify(obj),
        dataType: 'json',
        crossDomain:true,
        async:true,
        headers: {
          'api-key': "EdvqRnCQYlzqNLjLEv9Q"
        },
        contentType: 'application/json; charset=utf-8',
        success: function (result) {
          console.log("Success", result);
          window.localStorage.setItem('user-token', result.token);
          $(".reset_customer_password form").submit();
        },
        error: function (error) {
          console.log("Error", error);
          err_html = "<div class='note form-error'><p>Sorry, looks like something went wrong. Please correct the following and submit again:</p><ul class='disc'><li>We were unable to reset your password due to a technical issue. Please send an email to CustomerService@SumpAlarm.Com</li></ul></div>";
          jQuery(".reset_customer_password ").find(".form_errors").html(err_html);
          console.log("Password reset error: ", error);
        }
      });
    }
  });
  
  
  //   Validate User registration form
  function validate_customr_register_form() {
    var form = jQuery("#customr-form");
    form.validate({
      errorElement: 'div',
      errorClass: 'errors',
      highlight: function(element, errorClass, validClass) {
        jQuery(element).addClass("has-error");
      },
      unhighlight: function(element, errorClass, validClass) {
        jQuery(element).removeClass("has-error");
      },
      rules: {
        "customer[first_name]": {
          required: true,
        },
        "customer[last_name]": {
          required: true,
        },
        "customer[email]": {
          required: true,
        },
        "customer[password]": {
          required: true,
          minlength: 5
        },
      },
      errorPlacement: function(error, element) {
        error.insertAfter(element);
      },
      messages: {
        "customer[first_name]": {
          required: "First name is required",
        },
        "customer[last_name]": {
          required: "Last name is required",
        },
        "customer[email]": {
          required: "Email is required",
        },
        "customer[password]" : {
          required: "Password is required",
          minlength: "Password is too short (minimum is 5 characters)",
        },
      }
    });
    return form;
  }
  
  //  REGISTER USER API
  $(document).on('click', 'input[type="submit"][value="Create Account"]', function(e){
    var obj={};
    e.preventDefault();
    var parentform = jQuery("#customr-form");
    obj['first_name'] = $('input[name="customer[first_name]"]').val();
    obj['last_name'] = $('input[name="customer[last_name]"]').val();
    obj['email'] = $.trim(parentform.find("input[type='email']").val());
    obj['password'] = $.trim(parentform.find("input[type='password']").val());
    var form = validate_customr_register_form();
    
    if (form.valid() === true){
      $.ajax({
        url: BASE_URL+"/api/users/create_user/",
        type: 'POST',
        data: JSON.stringify(obj),
        dataType: 'json',
        crossDomain:true,
        async:true,
        headers: {
          'api-key': "EdvqRnCQYlzqNLjLEv9Q"
        },
        contentType: 'application/json; charset=utf-8',
        success: function (result) {
          // window.sessionStorage.setItem('user-token', result.token);
          window.localStorage.setItem('user-token', result.token);
          $("#customr-form").submit();
        },
        error: function (error) {
          err_html = "<div class='note form-error'><p>Sorry, looks like something went wrong. Please correct the following and submit again:</p><ul class='disc'><li>User with given email already exists.</li></ul></div>";
          $(".reg_form_errors").html(err_html);
          $(".reg_form_errors").show();
          jQuery('#customer_login').find(".form_errors").hide();
          document.getElementById("customer_login").reset();
        }
      });
    }
  });
  
})